import { ContactsTabs } from "@/pages/ContactsPage/Components/ContactsTabs";
import { ContactsPersonCard } from "../../../../ContactsPersonCard";
import { AdditionalInfo, TagsField } from "../../../../Fields";
import styles from "../../styles.module.scss";

export const Edit = () => {
  return (
    <div className={styles.root}>
      <div className={styles["person-card"]}>
        <ContactsPersonCard showEdit form />
        <div className={styles["tags"]}>
          <TagsField />
        </div>
        <AdditionalInfo />
      </div>
      <div className={styles["contacts-tabs"]}>
        <ContactsTabs />
      </div>
    </div>
  );
};
